module.exports = __webpack_public_path__ + "static/media/AoA_HomeSections_Bg04.915181ea.jpg";